import api from '../api/client';

// `tenantId` (optional) scopes the list to that tenant's roles plus application roles.
const getAll = async (appId, tenantId = null) => {
    if (!appId) throw new Error('App ID is required');
    const params = { app_id: appId };
    if (tenantId) params.tenant_id = tenantId;
    const res = await api.get(`/api/roles/get-all-roles`, { params });
    return res?.data?.data;
};

// Server-paged list for the Roles data table. `query` = { page, limit, sort, dir, search, filter_* }.
// Flag roles are left out server-side; getAll (role pickers) still returns everything.
const getPage = async (appId, query) => {
    if (!appId) throw new Error('App ID is required');
    const res = await api.get(`/api/roles/get-all-roles`, { params: { app_id: appId, ...query } });
    return res?.data?.data;
};

const addRole = async (appId, payload) => {
    const res = await api.post('/api/roles/add-new-role', payload, { params: { app_id: appId } });
    return res?.data;
};

const updateStatus = async (appId, payload) => {
    const res = await api.post('/api/roles/update-role-status', payload, { params: { app_id: appId } });
    return res?.data;
};

const deleteRole = async (appId, payload) => {
    const res = await api.delete('/api/roles/delete-role-from-app', {
        params: { app_id: appId },
        data: payload,
    });
    return res?.data;
};

const getRoleDetail = async (appId, rolename) => {
    if (!appId || !rolename) throw new Error('App ID and role name are required');
    const res = await api.get(`/api/roles/get-role-detail/${encodeURIComponent(rolename)}`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

// Archive / restore a role for ONE tenant (AIQ-463). `payload` = { role_id, tenant_id }.
const archiveRole = async (appId, payload) => {
    const res = await api.post('/api/roles/archive-role', payload, { params: { app_id: appId } });
    return res?.data;
};

const restoreRole = async (appId, payload) => {
    const res = await api.post('/api/roles/restore-role', payload, { params: { app_id: appId } });
    return res?.data;
};

const rolesService = { getAll, getPage, addRole, updateStatus, deleteRole, getRoleDetail, archiveRole, restoreRole };

export default rolesService;
